import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { conversionAPI } from '../../services/api';

// Async thunk for fetching conversion data
export const fetchConversionData = createAsyncThunk(
  'conversion/fetchConversionData',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await conversionAPI.getBonusConversion(userId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch conversion data');
    }
  }
);

const initialState = {
  currentUserId: null,
  conversionData: null,
  loading: false,
  error: null,
  currentOffers: null,
};

const conversionSlice = createSlice({
  name: 'conversion',
  initialState,
  reducers: {
    setCurrentUserId: (state, action) => {
      state.currentUserId = action.payload;
    },
    clearConversionData: (state) => {
      state.conversionData = null;
      state.currentOffers = null;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    updateCurrentOffers: (state, action) => {
      state.currentOffers = { ...state.currentOffers, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConversionData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConversionData.fulfilled, (state, action) => {
        state.loading = false;
        state.conversionData = action.payload;
        state.error = null;

        // Update current offers with data from API
        if (action.payload?.data) {
          const data = action.payload.data;
          state.currentOffers = {
            rakeback: data.rakeback ? (data.rakeback * 100) : 0,
            cashback: data.cashback ? (data.cashback * 100) : 0,
            reload: data.reload_max_usd || 0,
            jpm: data.jmp_status ? 'Active' : 'Inactive',
            bms: data.bms_bet_usd || 0,
            playzCash: data.piggyz_cash_usd || 0,
          };
        }
      })
      .addCase(fetchConversionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setCurrentUserId,
  clearConversionData,
  clearError,
  updateCurrentOffers,
} = conversionSlice.actions;

export default conversionSlice.reducer;